import { render, staticRenderFns } from "./MovieDetail.vue?vue&type=template&id=83327a7e&scoped=true&"
import script from "./MovieDetail.vue?vue&type=script&lang=js&"
export * from "./MovieDetail.vue?vue&type=script&lang=js&"
import style0 from "./MovieDetail.vue?vue&type=style&index=0&id=83327a7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83327a7e",
  null
  
)

export default component.exports